// Import all components here
import Dashboard from "./university/Dashboard/Dashboard";
import StudentDashboard from "./university/Dashboard/StudentDashboard";
import Professors from "./university/Professors/Professors";
import Staff from "./university/Staff/Staff";
import Students from "./university/Students/Students";
import SubjectClass from "./university/Departments/SubjectClass";
import Courses from "./university/Courses/Courses";
import CourseDetails from "./university/Courses/CourseDetails";
import Library from "./university/Library/Library";
import Holiday from "./university/Holiday/Holiday";
import Calendar from "./university/Calendar/Calendar";
import ChatApp from "./university/ChatApp/ChatApp";
import Contact from "./university/Contact/Contact";
import Payments from "./admin/Payments/Payments";
import Attandance from "./admin/Attandance/Attandance";
import Setting from "./admin/Setting/Setting";
import EmailView from "./university/Email/EmailView";
import Compose from "./university/Email/Compose";
import PageProfile from "./university/Page/PageProfile";
import PageInvoices from "./university/Page/PageInvoices";
import PagePricing from "./university/Page/PagePricing";
import PageTimeline from "./university/Page/PageTimeline";
import PageEmpty from "./university/Page/PageEmpty";
import OurCentre from "./university/OurCentre/OurCentre";
import Gallery from "./university/Gallery/Gallery";
import Login from "./Authentication/login";
import StudentRegistration from "./student/Registration";
import Signup from "./Authentication/signup";
import ForgotPassword from "./Authentication/forgotpassword";
import NotFound from "./Authentication/404";
import InternalServer from "./Authentication/500";
import AddUser from "./university/AddUser/AddUser";
import ViewUser from "./university/ViewUser/ViewUser";
import Timetable from "./university/Timetable/Timetable";
import UserAttendance from "./admin/Attandance/UserAttendance";
import ApplyLeaves from "./admin/Leave/ApplyLeaves";
import ApproveLeaves from "./admin/Leave/ApproveLeaves";
import AppliedLeaves from "./admin/Leave/AppliedLeaves";
import CreateSalary from "./admin/Salary/CreateSalary";
import ViewSalary from "./admin/Salary/ViewSalary";
import EditSalary from "./admin/Salary/EditSalary";
import GenerateSalary from "./admin/Salary/GenerateSalary";
import AllFaculties from "./admin/AllFaculties/AllFaculties";
// import AddSyllabus from "./admin/Syllabus/AddSyllabus";
// import ViewSyllabus from "./admin/Syllabus/ViewSyllabus";
import EditPermissions from "./university/Permissions/EditPermissions";
import ToggleRegistrationForm from "./admin/Admission/ToggleRegistrationForm";
import AllPaidRegistrations from "./admin/Admission/AllPaidRegistrations";
import AllUnPaidRegistrations from "./admin/Admission/AllUnPaidRegistrations";
import SearchRegistrations from "./admin/Admission/SearchRegistrations";
import GenerateRollNumber from "./admin/Admission/GenerateRollNumber";
import UgPayments from "./admin/Admission/UgPayments";
import PgPayments from "./admin/Admission/PgPayments";
import RecordPayments from "./admin/Admission/RecordPayments";
import CollegeFeePayment from "./admin/Admission/CollegeFeePayment";
import DownloadDocuments from "./admin/Admission/DownloadDocuments";
import ExaminationStatusCourseFeePayment from "./admin/Admission/ExaminationStatusCourseFeePayment";
import UpdateExamStatus from "./admin/Admission/UpdateExamStatus";
import AuthStudentLogin from "./admin/Admission/AuthStudentLogin";
import RecordCollegeFees from "./admin/Admission/RecordCollegeFees";
import CollegeFeesSystem from "./admin/Admission/CollegeFeesSystem";
import FundsManager from "./admin/Admission/FundsManager";

const Routes = [
  // {
  //   path: "/addSyllabus",
  //   name: "Syllabus",
  //   exact: true,
  //   pageTitle: "Add Syllabus",
  //   component: AddSyllabus,
  //   permission_code: "syllabus",
  // },
  // {
  //   path: "/viewSyllabus",
  //   name: "Syllabus",
  //   exact: true,
  //   pageTitle: "View Syllabus",
  //   component: ViewSyllabus,
  //   permission_code: "syllabus",
  // },
  {
    path: "/allFaculties",
    name: "view all faculties",
    exact: true,
    pageTitle: "Show all faculties",
    component: AllFaculties,
    permission_code: "allFaculties",
  },
  {
    path: "/salary/create-salary-slip",
    name: "create salary slip",
    exact: true,
    pageTitle: "Create salary slip",
    component: CreateSalary,
    permission_code: "salary",
  },
  {
    path: "/salary/view-salary-slip",
    name: "view salary slip",
    exact: true,
    pageTitle: "View Salary slips",
    component: ViewSalary,
    permission_code: "salary",
  },
  {
    path: "/salary/edit-salary-slip",
    name: "Edit salary slip",
    exact: true,
    pageTitle: "Edit Salary slips",
    component: EditSalary,
    permission_code: "salary",
  },
  {
    path: "/salary/generate-salary-slip",
    name: "Generate salary",
    exact: true,
    pageTitle: "Generate Salary",
    component: GenerateSalary,
    permission_code: "salary",
  },
  {
    path: "/gallery",
    name: "gallery",
    exact: true,
    pageTitle: "Gallery",
    component: Gallery,
  },
  {
    path: "/ourCentre",
    name: "ourCentre",
    exact: true,
    pageTitle: "OurCentre",
    component: OurCentre,
  },
  {
    path: "/pageEmpty",
    name: "pageEmpty",
    exact: true,
    pageTitle: "PageEmpty",
    component: PageEmpty,
  },
  {
    path: "/pageTimeline",
    name: "pageTimeline",
    exact: true,
    pageTitle: "PageTimeline",
    component: PageTimeline,
  },
  {
    path: "/pagePricing",
    name: "pagePricing",
    exact: true,
    pageTitle: "PagePricing",
    component: PagePricing,
  },
  {
    path: "/pageInvoices",
    name: "pageInvoices",
    exact: true,
    pageTitle: "PageInvoices",
    component: PageInvoices,
  },
  {
    path: "/pageProfile",
    name: "pageProfile",
    exact: true,
    pageTitle: "PageProfile",
    component: PageProfile,
  },
  {
    path: "/compose",
    name: "compose",
    exact: true,
    pageTitle: "Compose",
    component: Compose,
  },
  {
    path: "/emailView",
    name: "emailView",
    exact: true,
    pageTitle: "EmailView",
    component: EmailView,
  },
  {
    path: "/updatePassword",
    name: "updatePassword",
    exact: true,
    pageTitle: "Update Password",
    component: Setting,
  },
  {
    path: "/leave/apply-leave",
    name: "apply leave",
    exact: true,
    pageTitle: "leave",
    component: ApplyLeaves,
  },
  {
    path: "/leave/approve-leaves",
    name: "approve leaves",
    exact: true,
    pageTitle: "leave",
    component: ApproveLeaves,
    permission_code: "approve_leave",
  },
  {
    path: "/leave/applied-leaves",
    name: "applied leaves",
    exact: true,
    pageTitle: "leave",
    component: AppliedLeaves,
  },
  {
    path: "/attandance",
    name: "attandance",
    exact: true,
    pageTitle: "attandance",
    component: Attandance,
    permission_code: "attendance",
  },
  {
    path: "/payments",
    name: "payments",
    exact: true,
    pageTitle: "Payments",
    component: Payments,
  },
  {
    path: "/contact",
    name: "contact",
    exact: true,
    pageTitle: "Contact",
    component: Contact,
  },
  {
    path: "/chat",
    name: "chatApp",
    exact: true,
    pageTitle: "ChatApp",
    component: ChatApp,
  },
  {
    path: "/events",
    name: "calendar",
    exact: true,
    pageTitle: "Calendar",
    component: Calendar,
  },
  {
    path: "/holiday",
    name: "holiday",
    exact: true,
    pageTitle: "Holiday",
    component: Holiday,
    permission_code: "holiday",
  },
  {
    path: "/library",
    name: "library",
    exact: true,
    pageTitle: "Library",
    component: Library,
  },
  {
    path: "/courses",
    name: "courses",
    exact: true,
    pageTitle: "Courses",
    component: Courses,
  },
  {
    path: "/courseDetails",
    name: "courseDetails",
    exact: true,
    pageTitle: "CourseDetails",
    component: CourseDetails,
  },
  {
    path: "/subjectClass",
    name: "SubjectClass",
    exact: true,
    pageTitle: "SubjectClass",
    component: SubjectClass,
    permission_code: "subject_and_class",
  },
  {
    path: "/students",
    name: "students",
    exact: true,
    pageTitle: "Students",
    component: Students,
  },
  {
    path: "/staff",
    name: "staff",
    exact: true,
    pageTitle: "Staff",
    component: Staff,
  },
  {
    path: "/addUser",
    name: "addUser",
    exact: true,
    pageTitle: "Add User",
    isAddUser: true,
    component: AddUser,
    permission_code: "create_user",
  },
  {
    path: "/viewUser",
    name: "viewUser",
    exact: true,
    pageTitle: "View User",
    component: ViewUser,
  },
  {
    path: "/timetable",
    name: "timetable",
    exact: true,
    pageTitle: "Timetable",
    component: Timetable,
    permission_code: "timetable",
  },
  {
    path: "/myAttendance",
    name: "myAttendance",
    exact: true,
    pageTitle: "My Attendance",
    component: UserAttendance,
  },
  {
    path: "/professors",
    name: "professors",
    exact: true,
    pageTitle: "Professors",
    component: Professors,
  },
  {
    path: "/",
    name: "dashboard",
    exact: true,
    pageTitle: "Dashboard",
    component: Dashboard,
    permission_code: "news_notice",
  },
  {
    path: "/login",
    name: "login",
    exact: true,
    pageTitle: "Tables",
    component: Login,
  },
  {
    path: "/studentRegistration",
    name: "studentRegistration",
    exact: true,
    pageTitle: "Student Registration",
    component: StudentRegistration,
  },
  {
    path: "/signup",
    name: "signup",
    exact: true,
    pageTitle: "Tables",
    component: Signup,
  },
  {
    path: "/forgotpassword",
    name: "forgotpassword",
    exact: true,
    pageTitle: "Tables",
    component: ForgotPassword,
  },
  {
    path: "/notfound",
    name: "notfound",
    exact: true,
    pageTitle: "Tables",
    component: NotFound,
  },
  {
    path: "/internalserver",
    name: "internalserver",
    exact: true,
    pageTitle: "Tables",
    component: InternalServer,
  },
  {
    path: "/changePermissions",
    name: "changePermissions",
    exact: true,
    pageTitle: "Tables",
    component: EditPermissions,
    permission_code: "create_user",
  },
  {
    path: "/toggleRegistrationDate",
    name: "Toggle registration form",
    exact: true,
    pageTitle: "Toggle registration form",
    component: ToggleRegistrationForm,
    permission_code: "studentRegistration",
  },
  {
    path: "/allRegistrations/paidRegistrations",
    name: "Paid registrations",
    exact: true,
    pageTitle: "Paid registrations",
    component: AllPaidRegistrations,
  },
  {
    path: "/allRegistrations/unpaidRegistrations",
    name: "Unpaid registrations",
    exact: true,
    pageTitle: "Unpaid registrations",
    component: AllUnPaidRegistrations,
  },
  {
    path: "/searchRegistrations",
    name: "Search registrations",
    exact: true,
    pageTitle: "Search registrations",
    component: SearchRegistrations,
    permission_code: "searchRegistration",
  },
  {
    path: "/generateRollNo",
    name: "Generate roll no.",
    exact: true,
    pageTitle: "Generate roll no.",
    component: GenerateRollNumber,
    permission_code: "generateRollNo",
  },
  {
    path: "/payments/ugPayments",
    name: "UG payments",
    exact: true,
    pageTitle: "UG payments",
    component: UgPayments,
  },
  {
    path: "/payments/pgPayments",
    name: "PG payments",
    exact: true,
    pageTitle: "PG payments",
    component: PgPayments,
  },
  {
    path: "/payments/recordCollegeFees",
    name: "Record college entrance fees",
    exact: true,
    pageTitle: "Record college entrance fees",
    component: RecordCollegeFees,
  },
  {
    path: "/payments/recordPayments",
    name: "Record payments",
    exact: true,
    pageTitle: "Record payments",
    component: RecordPayments,
  },
  {
    path: "/updateExamStatus",
    name: "Update Examination status",
    exact: true,
    pageTitle: "Update Examination status",
    component: UpdateExamStatus,
  },
  {
    path: "/authStudentLogin",
    name: "Block/unblock student login",
    exact: true,
    pageTitle: "Block/unblock student login",
    component: AuthStudentLogin,
  },
  {
    path: "/collegeFeesSystem",
    name: "College fees system",
    exact: true,
    pageTitle: "College fees systemn",
    component: CollegeFeesSystem,
  },
  {
    path: "/funds",
    name: "Funds Manager",
    exact: true,
    pageTitle: "Funds Manager",
    component: FundsManager,
  }
];

export const studentRoutes = [
  {
    path: "/studentRegistration",
    name: "studentRegistration",
    exact: true,
    pageTitle: "Student Registration",
    component: StudentRegistration,
  },
  {
    path: "/",
    name: "studentDashboard",
    exact: true,
    pageTitle: "Student Dashboard",
    component: StudentDashboard,
    permission_code: "news_notice",
  },
  {
    path: "/downloadDocuments",
    name: "Download documents",
    exact: true,
    pageTitle: "Download documents",
    component: DownloadDocuments,
  },
  {
    path: "/collegeFees",
    name: "Entrance fees",
    exact: true,
    pageTitle: "Entrance fees",
    component: CollegeFeePayment,
  },
  {
    path: "/feeCalculation",
    name: "Exam status/fee payment",
    exact: true,
    pageTitle: "Exam status/fee payment",
    component: ExaminationStatusCourseFeePayment,
  },
  {
    path: "/updatePassword",
    name: "updatePassword",
    exact: true,
    pageTitle: "Update Password",
    component: Setting,
  }
];

export default Routes;
